import React from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import useWindowDimensions from "../../../hook/useWindowDimension";
import LogoSap from "../../../assets/img/offerModal/logos-sap.png";
import Offre1 from "../../../assets/img/offerModal/offre-1.png";
import Offre2 from "../../../assets/img/offerModal/offre-2.png";
import Offre3 from "../../../assets/img/offerModal/offre-3.png";

// Dans ce composant on trouve les différentes offre pour les clients B2C qui sont affichées dans la modal
const OfferChoices = ({setStep, dataUser, setShowOfferModal, idExt, setOpenFreeQuestionChatBot}) => {

    const history = useHistory();
    const {width} = useWindowDimensions();
    return (<>
        {idExt === "BPCE-B2C"
            ? <div className="modalBoxOffres" id={"modalBoxOffresBPCE"}>
                <div className="titleModale">
                    <h1>Nos accompagnements</h1>
                    <img src={LogoSap} className={"logos"}/>
                </div>
                <h3>Pour répondre à tous vos besoins et à ceux de votre proche et parce que chaque situation est unique,
                    nous
                    vous proposons 3 formules d&apos;accompagnement :</h3>
                <ul id="listOffres">

                    {/*OFFRE 49*/}
                    <li className={"li-BPCE-B2C"}
                        onClick={() => {
                            if (
                                // On s'assure que le user possède bien un customerId Stripe
                                dataUser.idStripe === "" ||
                                dataUser.idStripe.length === 0
                            ) {
                                // S'il n'en a pas, on le redirige vers le formulaire <OfferForm>
                                // C'est via ce formulaire que le customerId de Stripe est créé
                                setStep("offer-49");
                            } else {
                                // Si un customerId Stripe existe, cela veut forcément dire que le user a rempli ses coordonnées
                                // Donc on peut le rediriger directement vers le composant <Checkout> correspodant à l'offre. Dans ce composant, le user a la possibilité de corriger ses coordonnées via un bouton
                                // Rappel : setStep met à jour la valeur de step. step conditionne l'affichage des composant via un switch case en JSX dans le composant <OfferModal>
                                setStep("checkout-49");
                            }
                        }}
                    >
                        <div className="pricing">
                            <div className={"price-TTC"}>49€ TTC</div>
                            <div className={"price-CI"}>24,50€ après <br/> crédit d&apos;impôt*</div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre1}/>
                        </div>
                        <h1 className="title-offre">Avis d&apos;expert - S&apos;informer</h1>
                        <p>Une question précise à votre assistant personnel Prev&Care ? Obtenez une réponse
                            personnalisée immédiate à votre situation au téléphone et recevez une restitution dans les
                            24H00. </p>

                        <button className="submit-modal">Je choisis</button>
                    </li>


                    {/*OFFRE 190*/}
                    <li className={"li-BPCE-B2C"}
                        onClick={() => {
                            if (
                                // On s'assure que le user possède bien un customerId Stripe
                                dataUser.idStripe === "" ||
                                dataUser.idStripe.length === 0
                            ) {
                                // S'il n'en a pas, on le redirige vers le formulaire <OfferForm>
                                // C'est via ce formulaire que le customerId de Stripe est créé
                                setStep("offer-190");
                            } else {
                                // Si un customerId Stripe existe, cela veut forcément dire que le user a rempli ses coordonnées
                                // Donc on peut le rediriger directement vers le composant <Checkout> correspodant à l'offre. Dans ce composant, le user a la possibilité de corriger ses coordonnées via un bouton
                                // Rappel : setStep met à jour la valeur de step. step conditionne l'affichage des composant via un switch case en JSX dans le composant <OfferModal>
                                setStep("checkout-190");
                            }
                        }}
                    >
                        <div className="pricing">
                            <div className={"price-TTC"}>190€ TTC</div>
                            <div className={"price-CI"}>95€ après <br/> crédit d&apos;impôt*</div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre2}/>
                        </div>
                        <h1 className="title-offre">Diag&apos;Action - S&apos;orienter</h1>
                        <p>Vous souhaitez mettre en place un plan d&apos;action complet pour votre proche fragilisé
                            (aides
                            financières, démarches administratives, liste recommandée de prestataires) ? Votre assistant
                            personnel Prev&Care réalise une évaluation complète de votre situation et vous transmets en
                            24H00 un plan d&apos;action personnalisé complet reprenant l&apos;ensemble de vos démarches.
                        </p>

                        <button className="submit-modal">Je choisis</button>
                    </li>


                    {/*OFFRE 350*/}
                    <li className={"li-BPCE-B2C"}
                        onClick={() => {
                            if (
                                // On s'assure que le user possède bien un customerId Stripe
                                dataUser.idStripe === "" ||
                                dataUser.idStripe.length === 0
                            ) {
                                // S'il n'en a pas, on le redirige vers le formulaire <OfferForm>
                                // C'est via ce formulaire que le customerId de Stripe est créé
                                setStep("offer-350");
                            } else {
                                // Si un customerId Stripe existe, cela veut forcément dire que le user a rempli ses coordonnées
                                // Donc on peut le rediriger directement vers le composant <Checkout> correspodant à l'offre. Dans ce composant, le user a la possibilité de corriger ses coordonnées via un bouton
                                // Rappel : setStep met à jour la valeur de step. step conditionne l'affichage des composant via un switch case en JSX dans le composant <OfferModal>
                                setStep("checkout-350");
                            }
                        }}
                    >
                        <div className="pricing">
                            <div className={"price-TTC"}>350€ TTC</div>
                            <div className={"price-CI"}>175€ après <br/> crédit d&apos;impôt*</div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre3}/>
                        </div>
                        <h1 className="title-offre">En tandem - Déléguer</h1>
                        <p>Vous souhaitez une assistance totale pour la mise en œuvre de solutions pour votre proche
                            fragilisé ? Votre assistant personnel Prev&Care prend en charge l&apos;ensemble de vos
                            besoins,
                            réalise une mise en place des solutions retenues et accompagne la mission d&apos;aide
                            pendant 6
                            mois.</p>

                        <button className="submit-modal">Je choisis</button>
                    </li>


                </ul>
                <div className="text-ci" style={{marginTop: "2vh"}}>
                    * Cette prestation donne droit à un crédit d’impôt -
                    Article 199
                    sexdecies CGI. Le
                    crédit
                    d’impôt permet de déduire la moitié des frais engagés (charges sociales comprises) de
                    l’impôt sur le
                    revenu, dans la
                    limite d’un plafond qui varie entre 12 000 et 20 000 euros, soit une réduction d’impôt
                    maximale de 10
                    000 euros par
                    an. Si le contribuable est faiblement imposé ou non imposable, le contribuable est
                    remboursé de la
                    différence.
                </div>
            </div>
            : <div className="modalBoxOffres">
                <div className="titleModale">
                    <h1>Nos accompagnements</h1>
                    <img src={LogoSap} className={"logos"}/>
                </div>
                <h3>Pour répondre à tous vos besoins et à ceux de votre proche et parce que chaque situation est unique,
                    nous
                    vous proposons 3 formules d&apos;accompagnement :</h3>
                <ul id="listOffres">
                    <li
                        onClick={() => {
                            // Redirige vers les question gratuite
                            if (width > 599) history.push("/free-question");
                            else setOpenFreeQuestionChatBot(true);
                            // Et on ferme la modal
                            setShowOfferModal(false);
                        }}
                    >
                        <div className="pricing">
                            <div id={"service-gratuit"} style={{backgroundColor: "#f6f3f4", color: "#560329"}}>Service
                                gratuit
                            </div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre1}/>
                        </div>
                        <h1 className="title-offre">Question gratuite</h1>
                        <p>
                            Posez gratuitement votre question à un expert Prev&Care et découvrez les dispositifs pour
                            vous
                            et votre
                            proche.<br/>
                        </p>

                        <button className="submit-modal">Je choisis</button>
                    </li>

                    <li
                        onClick={() => {
                            if (
                                // On s'assure que le user possède bien un customerId Stripe
                                dataUser.idStripe === "" ||
                                dataUser.idStripe.length === 0
                            ) {
                                // S'il n'en a pas, on le redirige vers le formulaire <OfferForm>
                                // C'est via ce formulaire que le customerId de Stripe est créé
                                setStep("offer-589");
                            } else {
                                // Si un customerId Stripe existe, cela veut forcément dire que le user a rempli ses coordonnées
                                // Donc on peut le rediriger directement vers le composant <Checkout> correspodant à l'offre à 589€. Dans ce composant, le user a la possibilité de corriger ses coordonnées via un bouton
                                // Rappel : setStep met à jour la valeur de step. step conditionne l'affichage des composant via un switch case en JSX dans le composant <OfferModal>
                                setStep("checkout-589");
                            }
                        }}
                    >
                        <div className="pricing">
                            <div className={"price-TTC"}>589€ TTC</div>
                            <div className={"price-CI"}>294,50€ après <br/> crédit d&apos;impôt*</div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre2}/>
                        </div>
                        <h1 className="title-offre">1 an d&apos;accompagnement</h1>
                        <p>
                            Bénéficiez d’un accompagnement complet par un Care Manager dédié pendant 1 an pour vous et
                            votre
                            proche.<br/>
                            <strong>Payable en 3x sans frais</strong>
                        </p>

                        <button className="submit-modal">Je choisis</button>
                    </li>

                    <li
                        className="box-urgence"
                        onClick={() => {
                            if (
                                // On s'assure que le user possède bien un customerId Stripe
                                dataUser.idStripe === "" ||
                                dataUser.idStripe.length === 0
                            ) {
                                // S'il n'en a pas, on le redirige vers le formulaire <OfferForm>.
                                // C'est via ce formulaire que le customerId de Stripe est créé
                                setStep("offer-390");
                            } else {
                                // Si un customerId Stripe existe, cela veut forcément dire que le user a rempli ses coordonnées
                                // Donc on peut le rediriger directement vers le composant <Checkout> correspondant à l'offre à 390€. Dans ce composant, le user a la possibilité de corriger ses coordonnées via un bouton
                                // Rappel : setStep met à jour la valeur de step. step conditionne l'affichage des composant via un switch case en JSX dans le composant <OfferModal>
                                setStep("checkout-390");
                            }
                        }}
                    >
                        <div className="pricing">
                            <div className={"price-TTC"} style={{backgroundColor: "#c52834", color: "#FFFFFF"}}>390€ TTC
                            </div>
                            <div className={"price-CI"} style={{color: "#c52834"}}>195€ après <br/> crédit d&apos;impôt*
                            </div>
                        </div>
                        <div className="img-offre">
                            <img src={Offre3}/>
                        </div>
                        <h1 className="title-offre">Situation d&apos;urgence</h1>
                        <p>
                            Vous ou votre proche vous retrouvez dans une situation urgente ? Un Care Manager prend en
                            charge
                            votre
                            demande et vous apporte la solution adaptée.<br/>
                        </p>

                        <button className="submit-modal" style={{backgroundColor: "#c52834"}}>Je choisis</button>
                    </li>
                </ul>
            </div>
        }
    </>);
};

OfferChoices.propTypes = {
    setStep: PropTypes.func,
    dataUser: PropTypes.object,
    setShowOfferModal: PropTypes.func,
    idExt: PropTypes.string,
    setOpenFreeQuestionChatBot: PropTypes.func
};

export default OfferChoices;
